define('quiz_model',['bootstrap', 'utils'], function (news, utils) {

    var Quiz = function (data, vocabs, quizInAnIframe, iframeWrapper) {
        this.questions              = data.questions;
        this.totalNumberOfQuestions = this.questions.length;
        this.feedback               = data.feedback;
        this.score                  = 0;
        this.currentQuestion        = 1;
        this.questionImages         = [];
        this.questionVideos         = [];
        this.hideScore              = data.hideScore;
        this.useRunningScore        = vocabs.quizAllowAnswerChange ? false : data.useRunningScore;
        this.runningScore           = 0;
        this.hasUserClicked         = false;
        this.quizTitle              = vocabs.quizTitle;
        this.setupPubsubs();
        this.preLoadQuestionImages();
        this.preLoadQuestionVideos();
        this.quizInAnIframe         = quizInAnIframe;
        this.urlForIstats           = utils.getQuizUrl(quizInAnIframe, iframeWrapper);
        this.scorePlaceholderForMultipleClicks = false;
        this.iframeWrapper = iframeWrapper;
    };

    Quiz.prototype = {
        setupPubsubs: function () {
            var Quiz = this;
            news.pubsub.on('quiz:requestFirstQuestion', function () {
                Quiz.getFirstQuestion();
            });
            news.pubsub.on('quiz:getNextQuestion', function (answer) {
                Quiz.getNextQuestion(answer);
            });
            news.pubsub.on('quiz:reset', function () {
                Quiz.reset();
            });
            news.pubsub.on('quiz:runningScore', function (answer) {
                Quiz.addToRunningScore(answer);
            });
            news.pubsub.on('quiz:runningScoreWhenAnswerCanBeChanged', function (answer) {
                Quiz.addToScoreWhenAnswerCanBeChanged(answer);
            });
            news.pubsub.on('quiz:istatsCall', function (status) {
                Quiz.istatsLogger(status);
            });
        },
        addToRunningScore: function (answer) {
            if (answer) {
                if (!this.hasUserClicked) {
                    var encodedAnswer = utils.htmlEntitiesEncode(answer);
                    score = this.questions[(this.currentQuestion - 1)].options[encodedAnswer];
                    if (this.useRunningScore) {
                        this.calculateRunningScore(score);
                        news.pubsub.emit('quiz:renderRunningScore', [this.runningScore, this.totalNumberOfQuestions]);
                        this.hasUserClicked = true;
                    }
                    this.addToScore(score);
                }
            }
        },
        /**
         * If a user selects an answer and then changes to another answer, we need to make sure both scores are
         * NOT added to the running tally. This bit of code probably requires some re-engineering to become simpler.
         */
        addToScoreWhenAnswerCanBeChanged: function (answer) {
            if (answer) {
                var encodedAnswer = utils.htmlEntitiesEncode(answer);
                this.scorePlaceholderForMultipleClicks = this.questions[(this.currentQuestion - 1)].options[encodedAnswer];
            }
        },
        reset: function () {
            this.istatsLogger('quiz-restart');
            this.score = 0;
            this.currentQuestion = 1;
            this.runningScore = 0;
            this.getFirstQuestion();
        },
        getNextQuestion: function (answer) {
            if (this.scorePlaceholderForMultipleClicks) {
                this.addToScore(this.scorePlaceholderForMultipleClicks);
                this.scorePlaceholderForMultipleClicks = false;
            }
            this.nextQuestion();
        },
        addToScore: function (score) {
            this.score += parseInt(score, 10);
        },
        getFirstQuestion: function () {
            var first = this.questions[0];
            news.pubsub.emit('quiz:showQuestion', [first.question, first.options, first.optionsKeys, first.supportingText, first.feedback, first.feedbackImages, this.questionImages[1], this.questionVideos[1], first.videoVersionExists]);
            if (this.useRunningScore) {
                news.pubsub.emit('quiz:renderRunningScore', [0, this.totalNumberOfQuestions]);
            }
            news.pubsub.emit('quiz:progress', [this.currentQuestion, this.totalNumberOfQuestions]);
        },
        nextQuestion: function () {
            if (this.currentQuestion === 1) {
                this.istatsLogger('quiz-start');
            }

            if (this.useRunningScore) {
                this.hasUserClicked = false;
            }

            if ((this.currentQuestion + 1) > this.totalNumberOfQuestions) {
                this.istatsLogger('quiz-end');
                news.pubsub.emit('quiz:end', [this.score, this.getHighestPossibleScore(), this.getFeedback()]);
            }
            else {
                var next = this.questions[this.currentQuestion];
                this.currentQuestion += 1;
                news.pubsub.emit('quiz:showQuestion', [next.question, next.options, next.optionsKeys, next.supportingText, next.feedback, next.feedbackImages, this.questionImages[this.currentQuestion], this.questionVideos[this.currentQuestion], next.videoVersionExists]);
                news.pubsub.emit('quiz:progress', [this.currentQuestion, this.totalNumberOfQuestions]);
            }
        },
        getFeedback: function () {
            var Quiz = this,
                correctFeedback = null;

            for (var i = 0, len = this.feedback.length; i < len; i++) {
                if (Quiz.score <= this.feedback[i].maxScore) {
                    correctFeedback = this.feedback[i];
                    return correctFeedback;
                }
            }
        },
        getHighestPossibleScore: function () {
            var highScores = 0;
            news.$.each(this.questions, function (index, question) {
                var highestScoringOption = 0;
                news.$.each(question.options, function (key, value) {
                    if (value > highestScoringOption) {
                        highestScoringOption = parseInt(value, 10);
                    }
                });
                highScores += highestScoringOption;
            });
            return highScores;
        },
        preLoadQuestionImages: function () {
            var i,
                max,
                image;

            this.questionImages.push({}); //enable reference via question number (which starts from 1)
            for (i = 0, max = this.questions.length; i < max; i++) {
                if (this.questions[i].questionImg.length > 1) {
                    image = new Image();
                    image.src = this.questions[i].questionImg;
                    this.questionImages.push(image);
                } else {
                    this.questionImages.push({});
                }
            }
        },
        preLoadQuestionVideos: function () {
            var i,
                max,
                video;

            this.questionVideos.push({}); //enable reference via question number (which starts from 1)
            for (i = 0, max = this.questions.length; i < max; i++) {
                if (this.questions[i].questionVideo !== 'undefined'){
                    video = this.questions[i].questionVideo;
                    this.questionVideos.push(video);
                } else {
                    this.questionVideos.push({});
                }
            }
        },
        calculateRunningScore: function (score) {
            var i,
                options = this.questions[(this.currentQuestion - 1)].options,
                allScores = [],
                answerTopScore;

            for (i in options) {
                if (options.hasOwnProperty(i)) {
                    allScores.push(options[i]);
                }
            }

            answerTopScore = Math.max.apply(Math, allScores);
            this.runningScore = answerTopScore === parseInt(score, 10) ? this.runningScore + 1 : this.runningScore;
        },
        istatsLogger: function (status) {
            var self = this;

            var quizStatusDictionary = {
                'quiz-start': function () {
                    self.decideHowStatShouldFire('click', 'quiz-next-buton', {
                        'context': 'quiz started',
                        'details': 'answered 1st requested 2nd',
                        'quiz-title': self.quizTitle,
                        'url': self.urlForIstats
                    });
                },
                'quiz-end': function () {
                    self.decideHowStatShouldFire('click', 'quiz-next-buton', {
                        'context': 'quiz ended',
                        'details': 'reached quiz end',
                        'quiz-title': self.quizTitle,
                        'url': self.urlForIstats
                    });
                },
                'quiz-restart': function () {
                    self.decideHowStatShouldFire('click', 'quiz-btn--restart', {
                        'context': 'quiz restarted',
                        'details': 'restart after quiz end',
                        'quiz-title': self.quizTitle,
                        'url': self.urlForIstats
                    });
                }
            };

            var shareRegexMatch = status.match(/^quiz-share-(.*)$/);
            if (shareRegexMatch) {
                var shareNetwork = shareRegexMatch[1];
                this.decideHowStatShouldFire('click', 'share__tool--' + shareNetwork, {
                    'context': 'quiz shared via ' + shareNetwork,
                    'details': 'share attempt to ' + shareNetwork,
                    'quiz-title': this.quizTitle,
                    'url': this.urlForIstats
                });
            } else {
                quizStatusDictionary[status]();
            }
        },
        decideHowStatShouldFire: function (type, name, info) {
            if (this.quizInAnIframe) {
                this.fireStatViaFrameHost(type, name, info);
            } else {
                this.fireStat(type, name, info);
            }
        },
        fireStatViaFrameHost: function (type, name, info) {
            this.iframeWrapper.callIstats({
                actionType: type,
                actionName: name,
                viewLabel: info
            });
        },
        fireStat: function (type, name, info) {
            news.istats.log(type, name, info);
        }
    };

    return Quiz;
});

